import { Outlet } from 'react-router'
import * as React from 'react'
import { useUTMHandler } from '../common/utm'
import { useEffect } from 'react'

const AppMainView: React.FC = () => {
  const { utmSaved, saveUTMParams } = useUTMHandler()
  useEffect(() => {
    if (!utmSaved) {
      saveUTMParams()
    }
  }, [saveUTMParams, utmSaved])

  return (
    <div className='layout-wrapper layout-static'>
      <div id='google-ca' className='visually-hidden'></div>
      <Outlet />
    </div>
  )
}

export default AppMainView
